// src/components/MainContent/MainContent.jsx

import React from "react";

import {
  Route,
  Routes,
} from "react-router-dom";

import Dashboard from "../../pages/Admin/Dashboard/Dashboard";
import Users from "../../pages/Admin/Users/Users";
import ClubsDojoAdmin from "../../pages/Admin/ClubsDojoAdmin/ClubsDojoAdmin";
import NotificationList from "../../pages/Admin/NotificationList/NotificationList";
import Settings from "../../pages/Admin/Settings/Settings";
import ErrorPage from "../../pages/ErrorPage/ErrorPage";
import GroupesAdherentsAdmin from "../../pages/Admin/GroupesAdherentsAdmin/GroupesAdherentsAdmin";
import AttendanceStatsAdmin from "../../pages/Admin/AttendanceStatsAdmin/AttendanceStatsAdmin";

import { useSidebar } from "../../contexts/SidebarContext";

function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function MainContent() {
  const { isCollapsed } = useSidebar();

  return (
    <main
      className={cn(
        "relative min-h-screen w-full overflow-x-hidden",
        "bg-slate-100",
        "dark:bg-slate-950",
        "transition-[margin-left,width] duration-300 ease-out",
        "lg:w-auto",
        isCollapsed
          ? "lg:ml-[76px]"
          : "lg:ml-[280px]",
      )}
    >
      {/* Fond décoratif */}
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 overflow-hidden"
      >
        <div className="absolute left-[22%] top-[-180px] h-[430px] w-[430px] rounded-full bg-blue-400/[0.08] blur-[100px] dark:bg-blue-500/[0.07]" />

        <div className="absolute bottom-[-220px] right-[-120px] h-[520px] w-[520px] rounded-full bg-sky-300/[0.08] blur-[120px] dark:bg-indigo-500/[0.06]" />

        <div className="absolute inset-x-0 top-[92px] h-px bg-gradient-to-r from-transparent via-blue-300/30 to-transparent dark:via-blue-500/20" />
      </div>

      {/* Trame très légère */}
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 opacity-[0.018] dark:opacity-[0.025]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, currentColor 1px, transparent 0)",
          backgroundSize: "24px 24px",
        }}
      />

      <div className="relative z-10 min-h-screen">
        <Routes>
          <Route
            path="dashboard"
            element={<Dashboard />}
          />

          <Route
            path="utilisateurs"
            element={<Users />}
          />

          <Route
            path="club-dojo-admin"
            element={<ClubsDojoAdmin />}
          />

          <Route
            path="groupes-adherents"
            element={
              <GroupesAdherentsAdmin />
            }
          />

          <Route
            path="appels-clubs"
            element={
              <AttendanceStatsAdmin />
            }
          />

          <Route
            path="notifications"
            element={
              <NotificationList />
            }
          />

          <Route
            path="parametres"
            element={<Settings />}
          />

          <Route
            path="*"
            element={<ErrorPage />}
          />
        </Routes>
      </div>
    </main>
  );
}